export default {"src":"/_next/static/media/three-dots.7c32932e.svg","height":4,"width":16};